import confetti from 'canvas-confetti';
import { playAchievementSound } from './sounds';

export function triggerConfetti() {
  // Central burst
  confetti({
    particleCount: 100,
    spread: 70,
    origin: { y: 0.6 }
  });
  
  // Side bursts for dramatic effect
  confetti({
    particleCount: 50,
    angle: 60,
    spread: 55,
    origin: { x: 0 }
  });
  confetti({
    particleCount: 50,
    angle: 120,
    spread: 55,
    origin: { x: 1 }
  });
  
  // Play legendary sound for weekly goals
  playAchievementSound('legendary');
}

export function triggerMiniConfetti() {
  // Subtle version for daily goal
  confetti({
    particleCount: 50,
    spread: 60,
    origin: { y: 0.7 }
  });
  
  // Play rare sound for daily goal
  playAchievementSound('rare');
}

/**
 * Dispara `fn` apenas uma vez por chave persistente (localStorage).
 * Evita reexibir confete em remounts/refreshes para o mesmo evento.
 */
export function celebrateOnce(key: string, fn: () => void) {
  if (typeof window === 'undefined') return;
  try {
    const storageKey = `confetti:${key}`;
    if (window.localStorage.getItem(storageKey)) return;
    window.localStorage.setItem(storageKey, new Date().toISOString());
  } catch {
    // localStorage indisponível — ainda assim dispara
  }
  fn();
}
